// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__fCOuw","icon":"SortAdornment_icon__2cSNL","up":"SortAdornment_up__38yS1","down":"SortAdornment_down__10L2M","active":"SortAdornment_active__3fpX0"};